import { render, staticRenderFns } from "./CreateLocationCatalogue.vue?vue&type=template&id=1d1e43ba&scoped=true&"
import script from "./CreateLocationCatalogue.vue?vue&type=script&lang=ts&"
export * from "./CreateLocationCatalogue.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLocationCatalogue.vue?vue&type=style&index=0&id=1d1e43ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e43ba",
  null
  
)

export default component.exports